import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Chat/InteractiveTool/saveGoalActivateCardCopy";
const I18n = I18nUtil.createScoped(Translations);
/** UI14 Activate goal pilot copy (Figma 96138:33273 — translate 只读). */

export const SAVE_GOAL_ACTIVATE_COPY = {
  activateCta: I18n.t("Active my plan"),
  viewDetails: I18n.t("View details"),
  movesBadge: (count: number) =>
    I18n.t("%{var0} moves toward your goal", {
      var0: count,
    }),
  moreMoves: (count: number) =>
    I18n.t("+ %{var0} more moves", {
      var0: count,
    }),
} as const;
